<template>
    <div class="container" v-if="dataRedFila[0] && initialLoadComplete">
        <b-modal :model-value="modEditaRedFila" :no-close-on-backdrop="true" hide-header hide-footer centered class="custom-dialog">
            <div class="dialog-header">
                <span class="header-title">{{ labels.title }}</span> 
            </div>
            <div class="dialog-content">
                <div class="form-container">
                    <!-- Información principal -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.niif }}</label> 
                                <input type="number" v-model="dataRedFila[0].niif" placeholder="labels.niif" /> 
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.descripcion }}</label> 
                                <input type="text" v-model="dataRedFila[0].descripcion" 
                                    placeholder="labels.descripcion" /> 
                        </div>
                    </div>
                    <!-- Niveles -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.primerNivel }}</label> 
                                <input type="number" v-model="dataRedFila[0].primer_nivel" 
                                    placeholder="labels.primerNivel" /> 
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.segundoNivel }}</label> 
                                <input type="number" v-model="dataRedFila[0].segundo_nivel" 
                                    placeholder="labels.segundoNivel" /> 
                        </div>
                    </div>
                    <!-- Configuración -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.actual }}</label> 
                                <select v-model="dataRedFila[0].actual" class="modern-select"> 
                                    <option value="">{{ labels.select }}</option> 
                                    <option value="1">{{ labels.yes }}</option> 
                                    <option value="0">{{ labels.not }}</option> 
                                </select>
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.operacion }}</label> 
                                <select v-model="dataRedFila[0].operacion" class="modern-select"> 
                                    <option value="">{{ labels.select }}</option> 
                                    <option value="+">{{ labels.sumar }}</option> 
                                    <option value="-">{{ labels.restar }}</option> 
                                </select>
                        </div>
                    </div>
                    <!-- Pestañas de selección -->
                    <div class="form-field-full">
                        <label class="field-label">{{ labels.niifSelect }}</label> 
                        <div class="tabs-container">
                            <!-- Pestañas -->
                            <div class="tabs-header">
                                <button class="tab-button" :class="{ active: activeTab === 'niif' }"
                                    @click="changeTab('niif')">
                                    {{ labels.tabNiif }} 
                                </button>
                                <button class="tab-button" :class="{ active: activeTab === 'redefiniciones' }"
                                    @click="changeTab('redefiniciones')">
                                    {{ labels.tabRedefiniciones }} 
                                </button>
                            </div>
                            <!-- Contenido de pestañas -->
                            <div class="tab-content">
                                <!-- Pestaña NIIF -->
                                <div v-if="activeTab === 'niif'" class="niif-selection-container">
                                    <div class="search-bar">
                                          <input placeholder="labels.searchPlaceholder" v-model="searchTerm" 
                                                @input="filterNiifs" />
                                        <div class="selection-info">
                                          {{ labels.selected }}: {{ selectedNiifs?.length }} / {{ filteredNiifs?.length 
                                            }}
                                        </div>
                                    </div>
                                    <div class="niif-table-container">
                                        <table class="niif-table">
                                            <thead>
                                                <tr>
                                                    <th class="checkbox-column">
                                                        <md-checkbox :md-checked="selectAll"
                                                            @change="toggleSelectAll" />
                                                    </th>
                                                    <th class="niif-column sortable" @click="sortBy('niif')">
                                          {{ labels.niif }} 
                                                        <span class="sort-indicator" v-if="sortColumn === 'niif'">
                                          {{ sortDirection === 'asc' ? '↑' : '↓' }}                                                         </span>
                                                    </th>
                                                    <th class="desc-column sortable" @click="sortBy('descripcion')">
                                          {{ labels.description }} 
                                                        <span class="sort-indicator"
                                                            v-if="sortColumn === 'descripcion'">
                                          {{ sortDirection === 'asc' ? '↑' : '↓' }}                                                         </span>
                                                    </th>
                                                    <th class="level-column sortable" @click="sortBy('primer_nivel')">
                                          {{ labels.levelFirst }} 
                                                        <span class="sort-indicator"
                                                            v-if="sortColumn === 'primer_nivel'">
                                          {{ sortDirection === 'asc' ? '↑' : '↓' }}                                                         </span>
                                                    </th>
                                                    <th class="level-desc-column sortable"
                                                        @click="sortBy('firstLevelDesc')">
                                          {{ labels.levelFirstDesc }} 
                                                        <span class="sort-indicator"
                                                            v-if="sortColumn === 'firstLevelDesc'">
                                          {{ sortDirection === 'asc' ? '↑' : '↓' }}                                                         </span>
                                                    </th>
                                                    <th class="level-column sortable" @click="sortBy('segundo_nivel')">
                                          {{ labels.levelSecond }} 
                                                        <span class="sort-indicator"
                                                            v-if="sortColumn === 'segundo_nivel'">
                                          {{ sortDirection === 'asc' ? '↑' : '↓' }}                                                         </span>
                                                    </th>
                                                    <th class="level-desc-column sortable"
                                                        @click="sortBy('secondLevelDesc')">
                                          {{ labels.levelSecondDesc }} 
                                                        <span class="sort-indicator"
                                                            v-if="sortColumn === 'secondLevelDesc'">
                                          {{ sortDirection === 'asc' ? '↑' : '↓' }}                                                         </span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                          <tr v-for="niif in sortedNiifs" :key="niif.id"> 
                                                    <td class="checkbox-column">
                                          <md-checkbox v-model="niif._selected" 
                                                            @change="onNiifCheckboxChange(niif)"
                                                            class="custom-checkbox" />
                                                    </td>
                                          <td class="niif-column">{{ niif?.niif }}</td>                                           <td class="desc-column" :title="niif.nameNiif || niif.descripcion"> 
                                          {{ niif?.nameNiif || niif?.descripcion }}                                                     </td>
                                          <td class="level-column">{{ niif?.primer_nivel }}</td>                                                     <td class="level-desc-column"
                                          :title="getFirstLevelDescription(niif.primer_nivel)"> 
                                          {{ getFirstLevelDescription(niif?.primer_nivel) }}                                                     </td>
                                          <td class="level-column">{{ niif?.segundo_nivel }}</td>                                                     <td class="level-desc-column"
                                          :title="getSecondLevelDescription(niif.niif)"> 
                                          {{ getSecondLevelDescription(niif?.niif) }}                                                     </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-if="filteredNiifs?.length === 0" class="no-results">                                           {{ labels.noResults }} 
                                        </div>
                                    </div>
                                </div>
                                <!-- Pestaña Redefiniciones -->
                                <div v-if="activeTab === 'redefiniciones'" class="redefiniciones-selection-container">
                                    <div class="search-bar">
                                          <input placeholder="labels.searchRedefPlaceholder" 
                                                v-model="searchRedefinicion" @input="filterRedefiniciones" />
                                        <div class="selection-info">
                                          {{ labels.selected }}: {{ selectedRedefiniciones?.length }} / {{ 
                                          filteredRedefiniciones.length }} 
                                        </div>
                                    </div>
                                    <div class="redefiniciones-table-container">
                                        <table class="redefiniciones-table">
                                            <thead>
                                                <tr>
                                                    <th class="checkbox-column">
                                                        <md-checkbox :md-checked="selectAllRedef"
                                                            @change="toggleSelectAllRedef" />
                                                    </th>
                                                    <th class="niif-column sortable" @click="sortByRedef('niif')">
                                          {{ labels.niif }} 
                                                        <span class="sort-indicator" v-if="sortColumnRedef === 'niif'">
                                          {{ sortDirectionRedef === 'asc' ? '↑' : '↓' }}                                                         </span>
                                                    </th>
                                                    <th class="desc-column sortable"
                                                        @click="sortByRedef('descripcion')">
                                          {{ labels.description }} 
                                                        <span class="sort-indicator"
                                                            v-if="sortColumnRedef === 'descripcion'">
                                          {{ sortDirectionRedef === 'asc' ? '↑' : '↓' }}                                                         </span>
                                                    </th>
                                                    <th class="level-column">
                                          {{ labels.levelFirst }} 
                                                    </th>
                                                    <th class="level-column">
                                          {{ labels.levelSecond }} 
                                                    </th>
                                                    <th class="formulation-column">
                                          {{ labels.formulacion }} 
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                          <tr v-for="redef in sortedRedefiniciones" :key="redef.id" 
                                                    class="clickable-row">
                                                    <td class="checkbox-column">
                                          <md-checkbox v-model="redef._selected" 
                                                            @change="onRedefinicionCheckboxChange(redef)"
                                                            class="custom-checkbox" />
                                                    </td>
                                          <td class="niif-column">{{ redef?.niif }}</td>                                           <td class="desc-column" :title="redef.descripcion"> 
                                          {{ redef?.descripcion }}                                                     </td>
                                          <td class="level-column">{{ redef?.primer_nivel }}</td>                                           <td class="level-column">{{ redef?.segundo_nivel }}</td>                                           <td class="formulation-column" :title="redef.formulacion"> 
                                          {{ truncateFormulation(redef?.formulacion) }}                                                     </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-if="filteredRedefiniciones?.length === 0" class="no-results">                                           {{ labels.noRedefResults }} 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialog-actions">
                <div class="actions-left">
                    <b-button class="md-raised delete-btn" @click="confirmDelete">
                        <b-icon icon="trash" class="me-2"></b-icon>
                        {{ labels.delete }} 
                    </b-button>
                </div>
                <div class="actions-right">
                    <b-button class="md-raised cancel-btn" @click="closeDialog">
                        {{ labels.close }} 
                    </b-button>
                    <b-button class="md-raised md-primary save-btn" @click="confirmSave">
                        {{ labels.save }} 
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import PrimerNivel from '../../../services/PrimerNivel'; 
import SegundoNivel from '../../../services/SegundoNivel'; 
import PlanConsolidacion from '../../../services/PlanConsolidacion'; 
import RedefinicionFila from '../../../services/RedefinicionFila'; 
export default {
    name: 'EditaRedefinicionFila',
    props:['modEditaRedFila','dataRedFila','vigenciaSelected','codReporte'],
    data: () => ({
        listFirstLevel: [],
        listSecondLev: [],
        listNiif: [],
        filteredNiifs: [],
        selectedNiifs: [],
        searchTerm: '',
        selectAll: false,
        originalData: null,
        hasUnsavedChanges: false,
        isSaving: false,
        initialLoadComplete: false,
        sortColumn: 'niif',
        sortDirection: 'asc',
        activeTab: 'niif',
        listRedefiniciones: [],
        filteredRedefiniciones: [],
        searchRedefinicion: '',
        sortColumnRedef: 'niif',
        sortDirectionRedef: 'asc',
        selectedRedefiniciones: [],
        selectAllRedef: false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title: "Editar redefinición fila",
                    save: "Guardar",
                    close: "Cerrar",
                    delete: "Eliminar",
                    niif: "Niif",
                    descripcion: "Descripción",
                    primerNivel: "Primer nivel",
                    segundoNivel: "Segundo nivel",
                    actual: "Actual",
                    operacion: "Operación",
                    niifSelect: "Seleccionar NIIF",
                    select: "Seleccione...", 
                    yes: "SI",
                    not: "NO",
                    sumar: "Sumar",
                    restar: "Restar",
                    searchPlaceholder: "Buscar NIIF...", 
                    selected: "Seleccionados",
                    levelFirst: "Nivel 1",
                    levelSecond: "Nivel 2",
                    levelFirstDesc: "Desc. Nivel 1", 
                    levelSecondDesc: "Desc. Nivel 2", 
                    description: "Descripción",
                    noResults: "No se encontraron resultados",
                    tabNiif: "NIIFs",
                    tabRedefiniciones: "Redefiniciones",
                    searchRedefPlaceholder: "Buscar redefiniciones...", 
                    noRedefResults: "No se encontraron redefiniciones",
                    showing: "Mostrando",
                    formulacion: "Formulación"
                }
            }else{
                return {
                    title: "Edit row redefinition",
                    save: "Save",
                    close: "Close",
                    delete: "Delete",
                    niif: "Niif",
                    descripcion: "Description",
                    primerNivel: "First level",
                    segundoNivel: "Second level",
                    actual: "Current",
                    operacion: "Operation",
                    niifSelect: "Select NIIF",
                    select: "Select...", 
                    yes: "YES",
                    not: "NO",
                    sumar: "Add",
                    restar: "Subtract",
                    searchPlaceholder: "Search NIIF...", 
                    selected: "Selected",
                    levelFirst: "Level 1",
                    levelSecond: "Level 2",
                    levelFirstDesc: "Level 1 Desc",
                    levelSecondDesc: "Level 2 Desc",
                    description: "Description",
                    noResults: "No results found",
                    tabNiif: "NIIFs",
                    tabRedefiniciones: "Redefinitions",
                    searchRedefPlaceholder: "Search redefinitions...", 
                    noRedefResults: "No redefinitions found",
                    showing: "Showing",
                    formulacion: "Formulation"
                }
            }
        },
        sortedNiifs() {
            if (!this.filteredNiifs.length) return [];
            return [...this.filteredNiifs].sort((a, b) => {
                let aValue, bValue;
                switch (this.sortColumn) {
                    case 'niif':
                        aValue = parseInt(a.niif); 
                        bValue = parseInt(b.niif); 
                        break;
                    case 'descripcion':
                        aValue = (a.nameNiif || a.descripcion || '').toLowerCase(); 
                        bValue = (b.nameNiif || b.descripcion || '').toLowerCase(); 
                        break;
                    case 'primer_nivel':
                        aValue = parseInt(a.primer_nivel); 
                        bValue = parseInt(b.primer_nivel); 
                        break;
                    case 'segundo_nivel':
                        aValue = parseInt(a.segundo_nivel); 
                        bValue = parseInt(b.segundo_nivel); 
                        break;
                    case 'firstLevelDesc':
                        aValue = this.getFirstLevelDescription(a.primer_nivel).toLowerCase();
                        bValue = this.getFirstLevelDescription(b.primer_nivel).toLowerCase();
                        break;
                    case 'secondLevelDesc':
                        aValue = this.getSecondLevelDescription(a.niif).toLowerCase();
                        bValue = this.getSecondLevelDescription(b.niif).toLowerCase();
                        break;
                    default:
                        aValue = a[this.sortColumn];
                        bValue = b[this.sortColumn];
                }
                // Manejar valores nulos o undefined
                if (aValue == null) aValue = '';
                if (bValue == null) bValue = '';
                let result = 0;
                if (typeof aValue === 'string') {
                    result = aValue.localeCompare(bValue); 
                } else {
                    result = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
                }
                return this.sortDirection === 'desc' ? -result : result;
            });
        },
        sortedRedefiniciones() {
            if (!this.filteredRedefiniciones.length) return [];
            return [...this.filteredRedefiniciones].sort((a, b) => {
                let aValue, bValue;
                switch (this.sortColumnRedef) {
                    case 'niif':
                        aValue = parseInt(a.niif); 
                        bValue = parseInt(b.niif); 
                        break;
                    case 'descripcion':
                        aValue = (a.descripcion || '').toLowerCase(); 
                        bValue = (b.descripcion || '').toLowerCase(); 
                        break;
                    default:
                        aValue = a[this.sortColumnRedef];
                        bValue = b[this.sortColumnRedef];
                }
                let result = 0;
                if (typeof aValue === 'string') {
                    result = aValue.localeCompare(bValue); 
                } else {
                    result = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
                }
                return this.sortDirectionRedef === 'desc' ? -result : result;
            });
        }
    },
    watch: {
        dataRedFila: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal && newVal[0]) {
                    this.originalData = { ...newVal[0] };
                    if (this.initialLoadComplete) {
                        this.loadSelectedNiifs();
                    }
                } else {
                    // limpiar si no hay data
                    this.selectedNiifs = [];
                    this.listNiif.forEach(n => n._selected = false);
                }
            }
        },
        'dataRedFila[0].niif'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].descripcion'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].primer_nivel'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].segundo_nivel'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].actual'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].operacion'() { this.hasUnsavedChanges = true; },
        selectedNiifs: {
            handler() {
                this.hasUnsavedChanges = true;
                this.updateSelectAllState();
            },
            deep: true
        },
        modEditaRedFila(valNew) {
            if (valNew) {
                // abrir modal -> cargar datos
                this.$nextTick(() => {
                    this.loadNiifData();
                });
            } else {
                this.searchTerm = '';
                this.selectAll = false;
                this.initialLoadComplete = false;
                // Resetear ordenamiento al cerrar
                this.sortColumn = 'niif';
                this.sortDirection = 'asc';
            }
        }
    },
    methods:{
        sortBy(column) {
            if (this.sortColumn === column) {
                // Si ya está ordenando por esta columna, cambiar dirección
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                // Si es una nueva columna, ordenar ascendente por defecto
                this.sortColumn = column;
                this.sortDirection = 'asc';
            }
        },
        loadNiifData() {
            // Cargar lista de NIIF
            PlanConsolidacion.getPlanConsPorCompVige(this.vigenciaSelected, this.codReporte)
                .then((res) => { 
                    this.listNiif = res.data.planConsNiif || [];
                    // inicialmente todos sin seleccionar
                    this.listNiif.forEach(n => n._selected = false);
                    this.filteredNiifs = [...this.listNiif];
                    // Después marcar los seleccionados (si vienen)
                    setTimeout(() => {
                        this.loadSelectedNiifs();
                    }, 100);
                    // cargar descripciones de niveles
                    return this.loadLevelDescriptions();
                })
                .then(() => { 
                    this.initialLoadComplete = true;
                })
                .catch((err) => { 
                    console.log('Error cargando NIIF:', err); 
                    this.filteredNiifs = [];
                    this.initialLoadComplete = true;
                });
        },
        loadSelectedNiifs() {
            if (!this.dataRedFila[0]) {
                this.selectedNiifs = [];
                this.listNiif.forEach(n => n._selected = false);
                return;
            }
            // lista desde backend (puede venir como numbers o strings)
            let selectedCodes = [];
            if (this.dataRedFila[0].listaNiif && this.dataRedFila[0].listaNiif.length > 0) {
                selectedCodes = this.dataRedFila[0].listaNiif.map(n => parseInt(n));
            } else if (this.dataRedFila[0].formulacion) {
                selectedCodes = this.extractNiifCodesFromFormulation(this.dataRedFila[0].formulacion);
            }
            // marcar flags
            this.listNiif.forEach(niif => {
                niif._selected = selectedCodes.includes(parseInt(niif.niif)); 
            });
            // reconstruir selectedNiifs
            this.selectedNiifs = this.listNiif.filter(niif => niif._selected);
            this.updateSelectAllState();
        },
        extractNiifCodesFromFormulation(formulation) {
            if (!formulation) return [];
            const niifMatch = formulation.match(/Niif\(([^)]+)\)/i); 
            if (niifMatch) {
                return niifMatch[1].split(',')?.map(num => parseInt(num.trim()))?.filter(num => !isNaN(num));             }
            return formulation?.replace(/[+-]/g, ',').split(',')?.map(n => parseInt(n.trim()))?.filter(n => !isNaN(n));         },
        onNiifCheckboxChange(niif) {
            if (niif._selected) { 
                if (!this.selectedNiifs.some(n => n.niif === niif.niif)) this.selectedNiifs.push(niif);
            } else {
                this.selectedNiifs = this.selectedNiifs.filter(n => n.niif !== niif.niif);
            }
            this.updateSelectAllState();
        },
        loadLevelDescriptions() {
            return new Promise((resolve) => {
                PrimerNivel.getFirstLevelByReporte(this.codReporte)
                    .then((result) => { 
                        this.listFirstLevel = result.data.firstLevByReport || [];
                        const uniqueFirstLevels = [...new Set(this.listNiif
                            .filter(niif => niif.primer_nivel) 
                            .map(niif => niif.primer_nivel) 
                        )];
                        if (uniqueFirstLevels.length > 0) { 
                            this.loadAllSecondLevelDescriptions(uniqueFirstLevels).then(resolve);
                        } else {
                            resolve();
                        }
                    })
                    .catch((err) => { 
                        console.log(err); 
                        resolve();
                    });
            });
        },
        loadAllSecondLevelDescriptions(firstLevels) {
            return new Promise((resolve) => {
                this.listSecondLev = [];
                const promises = firstLevels.map(firstLevel => 
                    SegundoNivel.getAllLevelSecondByLevelFirstByReport(firstLevel, this.codReporte)
                        .then(res => { 
                            if (res.data.secondLevByFirstLev) { 
                                this.listSecondLev = [...this.listSecondLev, ...res.data.secondLevByFirstLev];
                            }
                        })
                        .catch(err => { 
                            console.log(`Error loading second levels for first level ${firstLevel}:`, err); 
                        })
                );
                Promise.all(promises).then(resolve); 
            });
        },
        filterNiifs() {
            if (!this.searchTerm) {
                this.filteredNiifs = [...this.listNiif];
            } else {
                const term = this.searchTerm.toLowerCase();
                this.filteredNiifs = this.listNiif.filter(niif => 
                    niif.niif.toString().includes(term) || 
                    (niif.nameNiif && niif.nameNiif.toLowerCase().includes(term)) || 
                    (niif.descripcion && niif.descripcion.toLowerCase().includes(term)) || 
                    (niif.primer_nivel && niif.primer_nivel.toString().includes(term)) || 
                    (niif.segundo_nivel && niif.segundo_nivel.toString().includes(term)) 
                );
            }
            this.updateSelectAllState();
        },
        updateSelectAllState() {
            if (this.filteredNiifs.length === 0) {
                this.selectAll = false;
                return;
            }
            this.selectAll = this.filteredNiifs.every(niif => niif._selected);
        },
        toggleSelectAll() {
            if (!this.selectAll) {
                this.filteredNiifs.forEach(niif => {
                    if (!niif._selected) { 
                        niif._selected = true; 
                        if (!this.selectedNiifs.some(n => n.niif === niif.niif)) this.selectedNiifs.push(niif);
                    }
                });
                this.selectAll = true;
            } else {
                this.filteredNiifs.forEach(niif => niif._selected = false);
                this.selectedNiifs = this.selectedNiifs.filter(s => !this.filteredNiifs.some(f => f.niif === s.niif));
                this.selectAll = false;
            }
        },
        isNiifSelected(niifCode) {
            return this.selectedNiifs.some(niif => niif.niif === niifCode);
        },
        getFirstLevelDescription(levelCode) {
            if (!levelCode) return '-';
            const level = this.listFirstLevel.find(item => item.primer_nivel == levelCode);
            return level ? level?.descripcion : '-'
        },
        getSecondLevelDescription(niif) {
            if (!niif) return '-';
            const level = this.listNiif.find(r_niif => r_niif.niif == niif);
            return level ? level?.nameSegundoNivel : '-'
        },
        getFormulationPreview() {
            if (this.selectedNiifs.length === 0) return '-';
            const niifCodes = this.selectedNiifs.map(niif => niif.niif);
            const operation = this.dataRedFila[0].operacion || '+';
            if (niifCodes?.length === 1) return niifCodes[0];             return niifCodes?.join(` ${operation} `);         },
        restoreOriginalValues() {
            if (this.originalData && this.dataRedFila[0]) {
                Object.assign(this.dataRedFila[0], this.originalData);
                this.loadSelectedNiifs();
            }
        },
        closeDialog() {
            if (this.hasUnsavedChanges && !this.isSaving) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?";
                if (window.confirm(message)) { 
                    this.restoreOriginalValues();
                    this.closeModal();
                }
            } else {
                this.closeModal();
            }
        },
        confirmSave() {
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea guardar los cambios?"
                : "Are you sure you want to save the changes?";
            if (window.confirm(message)) { 
                this.guardaRedFila();
            }
        },
        confirmDelete() {
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea eliminar esta fila?"
                : "Are you sure you want to delete this row?";
            if (confirm(message)) {
                this.eliminarFila();
            }
        },
        eliminarFila() {
            this.isSaving = true;
            RedefinicionFila.deleteRedefinicionFila(this.dataRedFila[0].id)
            .then((res) => { 
                this.$toast.success(res.data.message);
                this.closeModal();
                this.$emit('reload');
            })
            .catch((err) => { 
                console.log(err); 
                this.$toast.error("Error al eliminar la fila");
            })
            .finally(() => { 
                this.isSaving = false;
            });
        },
        guardaRedFila(){
            this.isSaving = true;
            const selectedNiifCodes = this.selectedNiifs.map(niif => niif.niif);
            let infoFila = {
                'id': this.dataRedFila[0].id,
                'codReporte': this.codReporte,
                'primer_nivel': this.dataRedFila[0].primer_nivel,
                'segundo_nivel': this.dataRedFila[0].segundo_nivel,
                'niif': this.dataRedFila[0].niif,
                'descripcion': this.dataRedFila[0].descripcion,
                'contable': 0,
                'cuenta': null,
                'actual': this.dataRedFila[0].actual,
                'operacion': this.dataRedFila[0].operacion,
                'formulacion': this.getFormulationPreview(),
                'listaNiif': selectedNiifCodes,
                'idUser': this.$store.state.userId
            }
            RedefinicionFila.updateRedefinicionFila(infoFila) 
            .then((res) => { 
                this.$toast.success(res.data.message);
                this.hasUnsavedChanges = false;
                this.closeModal();
                this.$emit('reload');
            })
            .catch((error) => { 
                console.log(error); 
                this.$toast.error("Error al guardar los cambios");
            })
            .finally(() => { 
                this.isSaving = false;
            });
        },
        loadRedefiniciones() {
            RedefinicionFila.getAllRedefinicionFilas(this.codReporte)
                .then(res => { 
                    this.listRedefiniciones = res.data.redefinicionFila || [];
                    // Filtrar para excluir la fila actual que se está editando
                    this.listRedefiniciones = this.listRedefiniciones.filter(item =>
                        item.id !== this.dataRedFila[0].id
                    );
                    // Inicializar propiedad _selected
                    this.listRedefiniciones.forEach(redef => redef._selected = false);
                    this.filteredRedefiniciones = [...this.listRedefiniciones];
                    this.selectedRedefiniciones = [];
                })
                .catch(err => { 
                    console.log('Error cargando redefiniciones:', err); 
                    this.listRedefiniciones = [];
                    this.filteredRedefiniciones = [];
                    this.selectedRedefiniciones = [];
                });
        },
        filterRedefiniciones() {
            if (!this.searchRedefinicion) {
                this.filteredRedefiniciones = [...this.listRedefiniciones];
            } else {
                const term = this.searchRedefinicion.toLowerCase();
                this.filteredRedefiniciones = this.listRedefiniciones.filter(item =>
                    item.niif.toString().includes(term) || 
                    (item.descripcion && item.descripcion.toLowerCase().includes(term)) 
                );
            }
        },
        sortByRedef(column) {
            if (this.sortColumnRedef === column) {
                this.sortDirectionRedef = this.sortDirectionRedef === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumnRedef = column;
                this.sortDirectionRedef = 'asc';
            }
        },
        onRedefinicionSelect(redefinicion) {
            const niifCodes = this.extractNiifCodesFromFormulation(redefinicion.formulacion);
            this.listNiif.forEach(niif => {
                niif._selected = niifCodes.includes(parseInt(niif.niif)); 
            });
            this.selectedNiifs = this.listNiif.filter(niif => niif._selected);
            this.updateSelectAllState();
            this.activeTab = 'niif';
            this.hasUnsavedChanges = true;
        },
        truncateFormulation(formulation) {
            if (!formulation) return '';
            if (formulation.length > 50) { 
                const niifMatch = formulation.match(/^(Niif\([^)]+\))/i); 
                if (niifMatch) {
                    const niifPart = niifMatch[1];
                    if (niifPart.length > 50) { 
                        const numbersMatch = niifPart.match(/Niif\(([^)]+)\)/i); 
                        if (numbersMatch) {
                            const numbers = numbersMatch[1].split(','); 
                            if (numbers.length > 8) { 
                                const truncatedNumbers = [
                                    ...numbers.slice(0, 5), 
                                    '...', 
                                    ...numbers.slice(-3) 
                                ].join(','); 
                                return `Niif(${truncatedNumbers})`;
                            }
                        }
                    }
                    return niifPart;
                }
                return formulation?.substring(0, 50) + '..? ';             }
            return formulation;
        },
        onRedefinicionCheckboxChange(redef) {
            if (redef._selected) { 
                if (!this.selectedRedefiniciones.some(r => r.id === redef.id)) {
                    this.selectedRedefiniciones.push(redef);
                }
            } else {
                this.selectedRedefiniciones = this.selectedRedefiniciones.filter(r => r.id !== redef.id);
            }
            this.updateSelectAllRedefState();
            this.applyRedefinicionesSelection();
        },
        // Aplicar selección de redefiniciones a NIIFs
        applyRedefinicionesSelection() {
            if (this.selectedRedefiniciones.length === 0) return;
            // Recolectar todos los NIIFs únicos de las redefiniciones seleccionadas
            const allNiifCodes = new Set();
            this.selectedRedefiniciones.forEach(redef => {
                const niifCodes = this.extractNiifCodesFromFormulation(redef.formulacion);
                niifCodes.forEach(code => allNiifCodes.add(code)); 
            });
            // Convertir Set a Array
            const uniqueNiifCodes = Array.from(allNiifCodes); 
            // Marcar los NIIFs correspondientes
            this.listNiif.forEach(niif => {
                niif._selected = uniqueNiifCodes.includes(parseInt(niif.niif)); 
            });
            // Actualizar lista de seleccionados
            this.selectedNiifs = this.listNiif.filter(niif => niif._selected);
            this.updateSelectAllState();
            this.hasUnsavedChanges = true;
        },
        // Seleccionar todas las redefiniciones filtradas
        toggleSelectAllRedef() {
            if (!this.selectAllRedef) {
                // Marcar todas
                this.filteredRedefiniciones.forEach(redef => {
                    if (!redef._selected) { 
                        redef._selected = true; 
                        if (!this.selectedRedefiniciones.some(r => r.id === redef.id)) {
                            this.selectedRedefiniciones.push(redef);
                        }
                    }
                });
                this.selectAllRedef = true;
            } else {
                // Desmarcar todas
                this.filteredRedefiniciones.forEach(redef => redef._selected = false);
                this.selectedRedefiniciones = this.selectedRedefiniciones.filter(
                    s => !this.filteredRedefiniciones.some(f => f.id === s.id)
                );
                this.selectAllRedef = false;
            }
            this.applyRedefinicionesSelection();
        },
        // Actualizar estado de "seleccionar todos" para redefiniciones
        updateSelectAllRedefState() {
            if (this.filteredRedefiniciones.length === 0) {
                this.selectAllRedef = false;
                return;
            }
            this.selectAllRedef = this.filteredRedefiniciones.every(redef => redef._selected);
        },
        // Al cambiar de pestaña, limpiar selección de redefiniciones si no hay NIIFs seleccionados
        changeTab(tab) {
            this.activeTab = tab;
            if (tab === 'redefiniciones' && this.listRedefiniciones.length === 0) {
                this.loadRedefiniciones();
            }
            // Limpiar selección de redefiniciones si no hay NIIFs seleccionados
            if (tab === 'redefiniciones' && this.selectedNiifs.length === 0) {
                this.clearRedefinicionesSelection();
            }
        },
        // Limpiar selección de redefiniciones
        clearRedefinicionesSelection() {
            this.selectedRedefiniciones = [];
            this.listRedefiniciones.forEach(redef => redef._selected = false);
            this.selectAllRedef = false;
        },
        closeModal(){
            this.$emit('cierraModal',false);
        }
    },
    mounted() {
        if (this.codReporte) {
            PrimerNivel.getFirstLevelByReporte(this.codReporte)
                .then((result) => { 
                    this.listFirstLevel = result.data.firstLevByReport || [];
                })
                .catch((err) => { 
                    console.log(err) 
                })
        }
        if (this.modEditaRedFila && this.dataRedFila[0]) {
            this.$nextTick(() => {
                this.loadNiifData();
            });
        }
    }
}
</script>
